import axios from 'axios';

export const departmentsApi = {
  getStats() {
    return axios.get('/api/departments/stats').then((r) => r.data);
  },

  getOrgDashboard() {
    return axios.get('/api/departments/org-dashboard').then((r) => r.data);
  },

  getAvailablePermissions() {
    return axios.get('/api/departments/available-permissions').then((r) => r.data);
  },

  list(organizationId) {
    const params = organizationId ? { organizationId } : {};
    return axios.get('/api/departments', { params }).then((r) => r.data);
  },

  getOne(id) {
    return axios.get(`/api/departments/${id}`).then((r) => r.data);
  },

  create(body) {
    return axios.post('/api/departments', body).then((r) => r.data);
  },

  update(id, body) {
    return axios.put(`/api/departments/${id}`, body).then((r) => r.data);
  },

  delete(id) {
    return axios.delete(`/api/departments/${id}`).then((r) => r.data);
  },
};
